'use strict';

import { EntityStatus } from '../enum/entityStatus';
import { investOptions, workplaceOptions } from '../../../sliders/options';

export default function () {
    return {
        restrict: 'A',
        template: require('../../dashboard/view/metric-filter.html'),
        controller: [
            '$scope', '$window', '$uibModal', '$utils', '$filterUtils', 'DashboardFiltersService',
            'OperatorService', 'PStatusService', 'AreaService', 'PhaseService',
            'MunicipalityService', 'MaintenanceKindService', 'SupportToolService', 'ProjectService',
            (
                $scope, $window, $modal, $utils, $filterUtils, DashboardFiltersService,
                OperatorService, PStatusService, AreaService, PhaseService,
                MunicipalityService, MaintenanceKindService, SupportToolService, ProjectService
            ) => {
                $scope.localFilters = DashboardFiltersService.getSidebarFilters();
                $scope.localFilters.area = $filterUtils.defaultEmptySelectorElement('<Все>');
                $scope.filters = DashboardFiltersService.getFilters();

                $scope.getOperatorDisplayName = OperatorService.getDisplayName;
                $scope.isBetween = OperatorService.isBetween;

                $scope.managerFilters = [`EXTRA:'role' EQ 'PROJECT_MANAGER'`, `EXTRA:'role' EQ 'ADMINISTRATOR'`];
                $scope.oivFilters = [`'oiv' EQ 'true'`];
                $scope.curatorOivFilters = [];
                $scope.curatorMizipFilters = [`'org.mizip' EQ 'true'`];
                $scope.coordorgFilters = [`'coordorg' EQ 'true'`];
                $scope.coordinatorFilters = [];

                $scope.apply = apply;
                $scope.cancel = cancel;
                $scope.reset = reset;

                $scope.statuses = [];
                $scope.areas = [];
                $scope.phases = [];
                $scope.municipalities = [];
                $scope.operators = [];
                $scope.maintenanceKinds = [];
                $scope.supportTools = [];
                $scope.onChangeArea = (id) => {
                    const isCurrent = $scope.localFilters.area ? $scope.localFilters.area.id === id : false;
                    $scope.localFilters.area = null;
                    if (!isCurrent) {
                        $scope.localFilters.area = $scope.areas.find(item => item.id === id);
                    }
                }

                $scope.investSliderOptions = investOptions;
                $scope.workplaceSliderOptions = workplaceOptions;

                load();

                function load() {
                    //statistic();
                    loadStatuses();
                    loadAreas();
                    loadPhases();
                    loadMunicipalities();
                    loadOperators();
                    loadMaintenanceKinds();
                    loadSupportTools();
                }

                function loadStatuses() {
                    PStatusService.api.get(
                        {
                            filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                            sorts: ['name:ASC'],
                        },
                    )
                        .$promise
                        .then(data => $scope.statuses = [$filterUtils.defaultEmptySelectorElement('<Все>')].concat(data._embedded));
                }

                function loadAreas() {
                    AreaService.api.get(
                        {
                            filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                            sorts: ['npp:ASC', 'name:ASC'],
                        },
                    )
                        .$promise
                        .then(data => {
                            $scope.areas = data._embedded;
                        });
                }

                function loadPhases() {
                    PhaseService.api.get(
                        {
                            filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                            sorts: ['npp:ASC', 'name:ASC'],
                        },
                    )
                        .$promise
                        .then(data => $scope.phases = [{
                            id: "none",
                            name: 'Не указано',
                        }].concat(data._embedded));
                }

                function loadMunicipalities() {
                    MunicipalityService.api.get(
                        {
                            filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                            sorts: ['npp:ASC', 'name:ASC'],
                        },
                    )
                        .$promise
                        .then(data => {
                            $scope.municipalities = [{
                                id: "none",
                                name: 'Не указано',
                            }].concat(data._embedded)
                    });
                }

                function loadOperators() {
                    OperatorService.api.numeric(null)
                        .$promise
                        .then(data => $scope.operators = data._embedded);
                }

                function loadMaintenanceKinds() {
                    MaintenanceKindService.api.get(
                        {
                            filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                            sorts: ['name:ASC'],
                        },
                    )
                        .$promise
                        .then(data => $scope.maintenanceKinds = [$filterUtils.defaultEmptySelectorElement('<Все>')].concat(data._embedded));
                }

                function loadSupportTools() {
                    SupportToolService.api.get(
                        {
                            filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                            sorts: ['name:ASC'],
                        },
                    )
                        .$promise
                        .then(data => $scope.supportTools = [$filterUtils.defaultEmptySelectorElement('<Все>')].concat(data._embedded));
                }

                /**
                 * Применить фильтра
                 */
                function apply() {
                    //statistic();
                    DashboardFiltersService.setSidebarFilters($scope.localFilters);
                    DashboardFiltersService.setFilters($scope.filters);
                    if ($window.innerWidth < 1380) {
                        $utils.openControlSidebar(false);
                    }
                }

                /**
                 * Отменить установку фильтров
                 */
                function cancel() {
                    $scope.localFilters = DashboardFiltersService.getSidebarFilters();
                    $scope.filters = DashboardFiltersService.getFilters();
                    $utils.openControlSidebar();
                }

                /**
                 * Сбросить фильтра
                 */
                function reset() {
                    $scope.localFilters = angular.copy(DashboardFiltersService.getDefaultSidebarFilters());
                    $scope.filters = angular.copy(DashboardFiltersService.getDefaultFilters());
                }
            }],
    };
}
